<template>
  <div id="app">
    <header>
      <div class="header-container">
        <div class="header-container-content">
          <div class="header-container-banner">
            <img class="header-container-logo" src="../src/assets/logo.png" />
            <div class="header-container-phone">
              <img src="../src/assets/phone.png" style="width: 32px; height: 37px" />
              <p class="header-container-phonenumber">0591-87600110</p>
            </div>
          </div>
        </div>
        <div class="header-container-banner-item">
          <ul>
            <li>
              <router-link class="header-container-banner-item-btn" to="/home">首页</router-link>
            </li>
            <li>
              <router-link class="header-container-banner-item-btn" to="/about" replace>关于盛鑫</router-link>
              <div class="m-nav-secondary m-nav-secondary-show">
                <ul class="u-nav-ywdt">
                  <li v-for="item in about_menulist" style="float: left">
                    <router-link
                      class="header-container-banner-item-btn-li"
                      exact
                      :title="item.Word_Text"
                      :to="'/about?id=' + item.Word_Value"
                      >{{ item.Word_Text }}</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <router-link class="header-container-banner-item-btn" to="/purchasenotice" replace>招标信息</router-link>
              <div class="m-nav-secondary m-nav-secondary-show">
                <ul class="u-nav-ywdt">
                  <li v-for="item in purchase_menulist" style="float: left">
                    <router-link
                      class="header-container-banner-item-btn-li"
                      exact
                      :title="item.Word_Text"
                      :to="'/purchasenotice?id=' + item.Word_Value"
                      >{{ item.Word_Text }}</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <!-- <li>
              <router-link class="header-container-banner-item-btn" to="/purchasenotice" replace>采购结果</router-link>
              <div class="m-nav-secondary m-nav-secondary-show">
                <ul class="u-nav-ywdt">
                  <li v-for="item in purchase_menulist" style="float: left;">
                    <router-link class="header-container-banner-item-btn-li" exact :title="item.Word_Text"
                      :to="'/purchasenotice?id=' + item.Word_Value">{{ item.Word_Text }}</router-link>
                  </li>
                </ul>
              </div>
            </li> -->
            <li>
              <router-link class="header-container-banner-item-btn" to="/Tender">网上竞价</router-link>
              <div class="m-nav-secondary m-nav-secondary-show">
                <ul class="u-nav-ywdt">
                  <li v-for="item in Tender_menulist" style="float: left">
                    <router-link
                      class="header-container-banner-item-btn-li"
                      exact
                      :title="item.Word_Text"
                      :to="'/Tender?id=' + item.Word_Value"
                      >{{ item.Word_Text }}</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <!-- <a class="header-container-banner-item-btn" href="/" >在线评标</a> -->
            <li>
              <router-link class="header-container-banner-item-btn" to="/Guide">办事指南</router-link>
              <div class="m-nav-secondary m-nav-secondary-show">
                <ul class="u-nav-ywdt">
                  <li v-for="item in guide_typelist" style="float: left">
                    <router-link
                      class="header-container-banner-item-btn-li"
                      exact
                      :title="item.Word_Text"
                      :to="'/Guide?id=' + item.Word_Value"
                      >{{ item.Word_Text }}</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <router-link class="header-container-banner-item-btn" to="/Policy">政策法规</router-link>
            <!-- <ul>
              <router-link class="header-container-banner-item-btn" to="/Download">保证金签退</router-link>
              <div class="m-nav-secondary m-nav-secondary-show">
                <ul class="u-nav-ywdt">
                  <li v-for="item in down_typelist" style="float: left;">
                    <router-link class="header-container-banner-item-btn-li" exact :title="item.Word_Text"
                      :to="'/Download?id=' + item.Word_Value">{{ item.Word_Text }}</router-link>
                  </li>
                </ul>
              </div>
            </ul> -->
            <router-link class="header-container-banner-item-btn" to="/about?id=5">联系我们</router-link>
            <a class="header-container-banner-item-btn" href="https://shengxin.easy-prt.com/home" target="_blank"
              rel="noopener noreferrer">盛鑫招采电子交易平台</a>
          </ul>
        </div>
      </div>
    </header>
    <router-view />
    <footer>
      <div class="box" style="padding-top: 40px">
        <div style="display: flex">
          <dl>
            <img class="header-container-logo" style="margin-left: 0px; margin-bottom: 30px" src="../src/assets/logo.png" />
            <dd>
              <span style="font-size: 18px; color: #666666">地址:福州市鼓楼区鼓东街道湖东路79号外运大厦七层</span>
            </dd>
          </dl>
          <dl class="footer-call">
            <dt class="footer-title" style="color: #df3e3e">联系盛鑫</dt>
            <div class="header-container-phone">
              <img src="../src/assets/phone.png" style="width: 32px; height: 37px" />
              <p class="header-container-phonenumber">0591-87600110</p>
            </div>
            <!-- <dd style="padding-top: 40px;">
              <span style="padding-right: 40px;">传真：0591-8888660</span>
              <span>电子邮箱：fffffff@163.com</span>
            </dd> -->
          </dl>
        </div>
        <div class="endnav" style="padding-top: 20px">
          <div class="footer-title" style="color: #666666">
            Copyright © 2007-2024 福建盛鑫招标代理有限公司 all rights reserved 技术支持：福州富制网络
            <a href="http://beian.miit.gov.cn/" target="_blank" style="float: right">闽ICP备09030285号</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import applicationUserManager from "./Auth/applicationusermanager";
import userAuth from "./Auth/UserAuth";
export default {
  name: "app",
  mixins: [userAuth],
  data: function () {
    return {
      sysUserName: "",
      about_menulist: [],
      purchase_menulist: [],
      guide_typelist: [],
      down_typelist: [],
      Tender_menulist: [
        {
          Word_Text: "竞价公告",
          Id: 1,
          Word_Value: 1,
        },
        {
          Word_Text: "补充公告",
          Id: 3,
          Word_Value: 3,
        },
        {
          Word_Text: "结果公告",
          Id: 2,
          Word_Value: 2,
        },
      ],
    };
  },
  updated() {
    this.sysUserName = window.localStorage.getItem("USER_NAME") || "";
  },
  created() {
    this.sysUserName = window.localStorage.getItem("USER_NAME") || "";
  },
  watch: {
    $route: async function (to, from) {
      //这里使用Id4授权认证，用Jwt，请删之；
      //await this.refreshUserInfo();
    },
  },
  mounted() {
    this.menudata();
  },
  methods: {
    async login() {
      try {
        await applicationUserManager.login();
      } catch (error) {
        console.log(error);
        this.$root.$emit("show-snackbar", { message: error });
      }
    },
    async logout() {
      try {
        window.localStorage.removeItem("USER_NAME");
        await applicationUserManager.logout();
        this.$store.commit("saveToken", "");
      } catch (error) {
        console.log(error);
        this.$root.$emit("show-snackbar", { message: error });
      }
    },
    menudata() {
      var that = this;
      that.$api.get("Config/GetGroupList", { groupkey: "IndustryType,GuideType,DownloadType,ColumnType" }, (r) => {
        that.about_menulist = r.response.filter(function (item) {
          return item.Word_Group_Key == "ColumnType" && item.Word_Value > 0;
        });
        that.purchase_menulist = r.response.filter(function (item) {
          return item.Word_Group_Key == "IndustryType";
        });
        that.guide_typelist = r.response.filter(function (item) {
          return item.Word_Group_Key == "GuideType";
        });
        that.down_typelist = r.response.filter(function (item) {
          return item.Word_Group_Key == "DownloadType";
        });
        window.localStorage.setItem("menulist", JSON.stringify(r.response));
      });
    },
  },
};
</script>

<style lang="css">
@import "./style/stylehome.css";
@import "./style/base.css";
@import "./style/m.css";
@import "./style/elBase.css";
</style>

<style lang="stylus">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #666666;
  height: 135px;
  background-color: #FFFFFF;
}
a {
  color: #222222;
}

.header-container {

  overflow: hidden;
  background-color: #FFFFFF;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  z-index: 100;
}

.header-container-content {
  max-width: 1440px;
  margin: 0 auto;
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
  .header-container-banner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 85px;
  }

.header-container-logo {
  float: left;
  color: #ec7259;
  margin-left : 100px;
  width: 452px;
  height: 64px;
}
.header-container-phone {
  display: flex;
  align-items: center;
}

.header-container-phonenumber {
  font-weight: 900;
  font-size: 25px;
  color: #C52D23;
}

.header-container-in, .header-container-in:focus, .header-container-in:hover {
  background-color: transparent;
  border-color: transparent;
}

.header-container-in {
  color: #969696;
}

.header-container-user-size {
  font-size: 16px;
  padding: 8px 16px;
}

.header-container-user-size {
  font-size: 16px;
  padding: 8px 16px;
}

.header-container-hv, .header-container-hv[disabled]:hover {
  color: #ec7259;
  background-color: #fff;
  border-color: #ec7259;
  margin-top: 7px;
}

.header-container-hv._1YbC5u, .header-container-hv._1YbC5u[disabled]:hover {
  color: #fff;
  background-color: #ec7259;
  border-color: #ec7259;
  margin-top: 7px;
}

[role=button], button {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.header-container-banner {
  box-sizing: content-box;
  padding-left: 16px;
  padding-right: 16px;
  margin-left: auto;
  margin-right: auto;
  background-color: #fff;
}

.header-container-banner-item {
  height: 60px;
  background-color: #C52D23;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
}
.header-container-banner-item ul {
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中 */
    padding: 0;
}
.header-container-banner-item-btn {
  display: block;
  align-items: center;
  font-size: 17px;
  color: #FFFFFF;
  padding: 0 40px;
  cursor: pointer;
  float: left;
  line-height: 60px;
}
.header-container-banner-item-btn-li {
  display: block;
  align-items: center;
  font-size: 17px;
  color: #222222;
  padding: 0 30px;
  cursor: pointer;
  float: left;
  line-height: 60px;
}
.footer-title {
  font-size: 18px;
  color:#222222;
  padding: 0px 60px 20px 0px;
}
.footer-call {
  padding-left: 300px;
  color:#666666;
}
.footer-call span{
  font-size: 18px;
}

.m-nav-secondary {
  width: 100%;
  height: 60px;
  color: #222222;
  background: #FFFFFF;
  position: fixed;
  left: 0;
  top: 145px;
  display: none;
  border-radius: 0px 0px 0px 0px;
}
.u-nav-ywdt li {
  font-size: 16px;
  width: auto;
  margin: 0;
  line-height: 80px;
}
.header-container-banner-item-btn:hover {
  color: #C52D23;
  background-color: #FFF4F3;
}
.header-container-banner-item-btn:hover + .m-nav-secondary-show{
  display: block;
 }
 .m-nav-secondary:hover {
  display: block;
 }
 .m-nav-secondary a:hover {
  color: #C52D23;
}
</style>
